import { Component, OnInit } from '@angular/core';
import { Airport } from './../../models/airport';
import { AirportListService } from './../../services/airport/airport-list.service';
import { Subscription, from } from 'rxjs';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-airport-list',
  templateUrl: './airport-list.component.html',
  styleUrls: ['./airport-list.component.scss'],
})
export class AirportListComponent implements OnInit {
  airportList: Airport[];
  private airportSubscription: Subscription;
  noData: number;
  homeAirportExist: boolean;
  // tslint:disable-next-line: max-line-length
  constructor(private airportListService: AirportListService, private modalController: ModalController) {
    this.noData = 0;
    this.airportList = [];
    this.homeAirportExist = this.airportListService.getSelectedAirport() ? true : false;
  }

  ngOnInit() {
    this.airportSubscription = this.airportListService.airportList.subscribe(receivedAirportList => {
      if (receivedAirportList && receivedAirportList.length > 0) {
        this.airportList = receivedAirportList;
      } else {
        this.noData = 1;
      }
    });
    this.airportListService.getAllAirports();
  }

  closeModal() {
    // this.airportListService.setSelectedAirport(selectedAirport.airportCode);
    this.modalController.dismiss();
  }
  filterAirportLIst(event) {
    // tslint:disable-next-line: prefer-const
    let searchTerm = event.srcElement.value;
    if (searchTerm.length >= 3) {
      this.airportList = [];
      this.noData = 0;
      this.airportListService.getAllAirports(searchTerm);
    }
  }
  // tslint:disable-next-line: use-life-cycle-interface
  ngOnDestroy() {
    this.airportSubscription.unsubscribe();
  }
  filterAirportLIstOnEnter(event) {
    // tslint:disable-next-line: prefer-const
    let searchTerm = event.srcElement.value;
    this.airportList = [];
    this.noData = 0;
    this.airportListService.getAllAirports(searchTerm);
  }
}
